import { apiFetch } from './apiFetch'
import { postAdminLocation, getPlace } from './api'

export const getPlaces = async (location, limit = 25) => {
  const req = await apiFetch({
    path: `/places?lat=${location.coords.latitude}&lng=${
      location.coords.longitude
    }&limit=${limit}${
      location.filters.length > 0
        ? `&filters=${encodeURIComponent(location.filters)}`
        : ''
    }&date=${new Date().toLocaleString()}`,
    method: 'get'
  })
  return { type: 'GET_PLACES', data: req.addresses }
}

export const createAdminPlace = async (payload) => {
  const req = await postAdminLocation(payload)
  return { type: 'CREATE_ADMIN_PLACE_SUCCESS', data: req.location }
}

export const fetchPlace = async (id) => {
  const res = await getPlace(id)

  return {
    type: 'GET_PLACE_SUCCESS',
    data: res.location
  }
}
